import {basicColor} from '@/styles/template'

export default {
    title: 'dark',


    boxShadow: {
        Small: '0px 1px 2px rgba(19, 20, 21, 0.35)',
        Normal: '1px 33px 20px rgba(19, 20, 21, 0.1)',
        Middle: '8px 14px 21px rgba(19, 20, 21, 0.35)',
        Long: '-1px -33px 20px rgba(19, 20, 21, 0.1), 0px 50px 64px rgba(19, 20, 21, 0.25)',
        Extreme: '1px 50px 64px rgba(19, 20, 21, 0.5), -1px -2px 20px rgba(19, 20, 21, 0.6)',
    },

    color: {
        Text: basicColor.faintGray,
        LightItem: basicColor.midGrayDarkTheme,
        MidtoneItem: basicColor.darkGrayDarkTheme,
        Item: basicColor.blackDarkTheme,
        Background: basicColor.deepDarkDarkTheme,
        Overlay: basicColor.transparent,
    }
}